<script>
    import Icon from '../../components/Icon.svelte';
    import { useNavigate } from 'svelte-navigator';
  import ButtonRounded from '../../common/ButtonRounded.svelte';

    const navigate = useNavigate();
    
    let review = {
        category: "",
        message: "",
    }
    let event = ""
    let errors = {}
    let stages = [
        "start",
        "review",
        "thank-you"
    ]
    let stage = 0

    const initReview = () => {
        if (!review.category ) {
            errors.category = "Category is required";
            return
        }
        
        event = "loading";
        setTimeout(() => {
            stage = 1;
            event = "";
        }, 2000);
    }
    
</script>

<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="display-flex">
            <div class="flex flex-col">
                {#if stages[stage] === stages[0]}
                <div class="relative mx-8 mt-12 mb-4 text-gray-500 text-xs">
                    <strong class="text-black text-lg">
                        We're sorry, we're unable to take your call at the moment.
                    </strong>
                    Please leave a message, and we'll get back to you as soon as possible.
                    <div class="mt-4">
                        <div class="">
                            <span class="text-xs">
                                Select Categories
                            </span>
                            <select
                                bind:value={review.category}
                                class="border-0 border-b border-black px-2 py-1 text-sm w-full"
                            >
                                <option>Sales Enquiries</option>
                                <option>Product/Service Issue</option>
                                <option>Payment Issues</option>
                                <option>Report or Feedback</option>
                            </select>
                        </div>
                        <div class="mt-4">
                            <!-- <span class="text-xs">
                                Enter your message
                            </span> -->
                            <div class="flex">
                                <input
                                    placeholder="Enter your message"
                                    bind:value={review.message}
                                    required
                                    class="border-0 border-b border-black w-full px-2 py-1 text-sm"
                                />
                            </div>
                        </div>
                        <ButtonRounded
                            disabled={false}
                            on:click={initReview}
                            size=8
                            title=""
                            className="bg-gradient-to-r from-cyan-500 to-blue-500 border border-blue-800 h-10 mt-4 flex-inline text-white w-full"
                        >
                        Submit
                        </ButtonRounded>
                        {#if errors.message}
                            <small class="error">{ errors.message }</small>
                        {/if}
                    </div>
                </div>
                {/if}
                {#if stages[stage] === stages[1]}
                <div class="relative flex flex-col justify-center items-center mx-8 my-16 text-gray-500 text-center">
                    <img src="images/icons/thanks.png" width="50px" alt="thanks">
                    <strong>
                        Thank you for leaving your message!
                    </strong>
                    <br/>
                    <span class="text-xs">
                        We've received your message and will get back to you shortly.
                    </span>
                    <ButtonRounded
                        disabled={false}
                        on:click={() => navigate("/")}
                        size=8
                        title=""
                        className="bg-gradient-to-r from-cyan-500 to-blue-500 border border-blue-800 h-10 mt-4 flex-inline text-white px-8"
                    >
                        Return home
                    </ButtonRounded>
                </div>
                {/if}
                {#if event !== ""}
                <div class="flex mx-1">
                    <span class={`${event === "loading" ? "animate-spin" : ""} mx-2`}>
                        <Icon icon={event} size={24} color="#30A059" />
                    </span>
                    <span class="mx-2">
                        {#if event === "loading"}
                            Connecting.
                        {:else}
                            Ringing.
                        {/if}
                    </span>
                </div>
                {/if}
            </div>
        </div>
    </div>
</div>

<style lang="scss">
</style>